import { render, staticRenderFns } from "./success.vue?vue&type=template&id=3036a2a3&scoped=true"
import script from "./success.vue?vue&type=script&lang=js"
export * from "./success.vue?vue&type=script&lang=js"
import style0 from "./success.vue?vue&type=style&index=0&id=3036a2a3&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3036a2a3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/godata/pipelines/eShop-Portal-Web-Release-Prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3036a2a3')) {
      api.createRecord('3036a2a3', component.options)
    } else {
      api.reload('3036a2a3', component.options)
    }
    module.hot.accept("./success.vue?vue&type=template&id=3036a2a3&scoped=true", function () {
      api.rerender('3036a2a3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/auditcenter/components/success.vue"
export default component.exports